import { render, staticRenderFns } from "./DeleteControls.vue?vue&type=template&id=738c2384&scoped=true&"
import script from "./DeleteControls.vue?vue&type=script&lang=js&"
export * from "./DeleteControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c2384",
  null
  
)

export default component.exports